import { render, staticRenderFns } from "./IsPremiseVacantQuestion.vue?vue&type=template&id=99ff143c&scoped=true"
import script from "./IsPremiseVacantQuestion.vue?vue&type=script&lang=ts"
export * from "./IsPremiseVacantQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ff143c",
  null
  
)

export default component.exports